var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabelselectTime',_vm._g(_vm._b({attrs:{"value-format":_vm.valueFormat,"format":_vm.format,"label":_vm.label},on:{"focus":_vm.selectTime}},'LabelselectTime',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }